// @flow

import React from 'react'
import { connect } from 'react-redux'
import { Field, reduxForm } from 'redux-form'
import bindAll from 'lodash/bindAll'
import RenderSelect from './RenderSelect'
import RenderTextarea from './RenderTextarea'
import validateForUserRegisterWizardForm from './validateForUserRegisterWizardForm'
import { usersSaveDataRequest } from '../../../actions/users'

type Props = {
	pristine: boolean,
	submitting: boolean,
	handleSubmit: Function,
	asyncValidating: boolean,
	usersSaveDataRequest: Function
};

class UserRegisterWizardFormSecondPage extends React.Component<Props> {
	constructor(props) {
		super(props)

		bindAll(this, [
			'handleSaveData'
		])
	}

	handleSaveData(e) {
		this.props.usersSaveDataRequest('UserRegisterWizardForm')
	}

	render() {
		const {
			pristine,
			submitting,
			handleSubmit,
			asyncValidating
		} = this.props

		return(
			<form onSubmit={handleSubmit(this.handleSaveData)}>
				<div className="well-form rounded-sm" id="step2">
          <h3 className="heading3 semibold m-0 m-b-40">TELL US YOUR RECRUITMENT NEEDS</h3>
          <Field
          	component={RenderSelect}
          	name="total_roles_description"
          	id="roles"
          	label="How many roles are you recruiting each year?" />
          <Field
          	component={RenderTextarea}
          	name="assist_description"
          	rows="6"
          	cols="80"
          	id="desc"
          	label="How do you hope Astronaut can assist?" />
          <div className="center m-t-56 m-b-24">
            <button
            	disabled={submitting || pristine || asyncValidating}
							className="btn btn-primary"
							type="submit">Start Free Trial</button>
          </div>
          <div className="center">
            By clicking "Start Free Trial", you agree to Astronaut's <a href={'/termsofservice'} target="_blank" rel="noopener noreferrer" className="underline">Terms of Service</a> and <a href={'/privacypolicy'} target="_blank" rel="noopener noreferrer" className="underline">Privacy Policy</a>.
          </div>
        </div>
			</form>
		)
	}
}

UserRegisterWizardFormSecondPage = reduxForm({
  form: 'UserRegisterWizardForm',
  destroyOnUnmount: false,
  forceUnregisterOnUnmount: true,
  validate: validateForUserRegisterWizardForm
})(UserRegisterWizardFormSecondPage)

const mapDispatchToProps = (dispatch) => {
	return {
		usersSaveDataRequest: (formName) => dispatch(usersSaveDataRequest(formName))
	}
}

export default connect(null, mapDispatchToProps)(UserRegisterWizardFormSecondPage)
